import { RecognitionRecipients } from '@kudos/http-client'
import Typography from '@mui/material/Typography'
import { T } from '@transifex/react'

type RecipientHeaderProps = {
  recipients: RecognitionRecipients[]
}
const recipientsLabel = (recipients: RecognitionRecipients[]) =>
  recipients.length > 0 ? recipients.map(recipient => recipient.name).join(', ') : '-'

const RecognitionRecipientsTitle: React.FC<RecipientHeaderProps> = ({ recipients }) => {
  return (
    <Typography
      variant="caption"
      noWrap
      sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis' }}>
      <T _str="To: {recipients}" recipients={recipientsLabel(recipients)} />
    </Typography>
  )
}

export default RecognitionRecipientsTitle
